import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { errorMsg, validateDecimal } from '../../../../../../../Apis/functions';
import { UpdateDeductionPolicy } from '../../../../../../../reduxToolkit/DeductionPolicy/DeductionPolicyApi';
import { DEDUCTION_POLICY_MODEL } from '../Model/Model';

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTitle: Full Stack Developer
 */

/**
 * Logic hook for the update deduction policy modal.
 * @param {boolean} show - Controls modal visibility; populates form from row when transitioning to true.
 * @param {Object} row - The policy row to edit.
 * @param {Function} onHide - Closes the modal.
 * @param {Function} onSuccess - Called after a successful update to refresh the list.
 */
const DeductionPolicyUpdateApp = ({ show, row, onHide, onSuccess }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [item, setItem] = useState({ ...DEDUCTION_POLICY_MODEL });
    const [emptyFields, setEmptyFields] = useState(false);
    const [isValidValue, setIsValidValue] = useState(true);
    const [isValidValueText, setIsValidValueText] = useState('this_value_must_be_greater_than_0');

    useEffect(() => {
        if (show && row) {
            setItem({ ...DEDUCTION_POLICY_MODEL }.set(row));
            setEmptyFields(false);
        }
    }, [show]);

    useEffect(() => {
        const { isValid, text } = validateDecimal(item.value);
        setIsValidValue(isValid);
        if (text) setIsValidValueText(text);
    }, [item?.value]);

    const handleSubmit = () => {
        const { isValid } = validateDecimal(item.value);
        if (!item.isValid() || !isValid) {
            setEmptyFields(true);
            if (!isValid) setIsValidValue(false);
            return;
        }
        dispatch(UpdateDeductionPolicy(item.toRegister())).then(({ payload: { data: { success, code } } }) => {
            if (success) {
                toast.success(t('has_been_updated_successfully'));
                onHide();
                onSuccess();
            } else errorMsg(code);
        });
    };

    return { t, item, setItem, emptyFields, isValidValue, isValidValueText, handleSubmit };
};

export default DeductionPolicyUpdateApp;
